import ModalHeader from '../ModalHeader/ModalHeader'
import styles from './FilterModal.module.css'
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import CustomModal from '../UI/CustomModal/CustomModal'
import { useState } from 'react'
import FilterCompanyMobile from '../FilterCompanyMobile/FilterCompanyMobile'
import { CompaniesType } from '../../redux/actions/types'
import FilterPlacesMobile from '../FIlterPlacesMobile/FilterPlacesMobile'

interface Props {
  onClickHandler: () => void
  companies: CompaniesType[]
  setUserFilter: React.Dispatch<React.SetStateAction<string>>
  setPlaceFilter: React.Dispatch<React.SetStateAction<string>>
  placeNames: string[]
}

const FilterModal: React.FC<Props> = ({
  onClickHandler,
  companies,
  setUserFilter,
  setPlaceFilter,
  placeNames,
}) => {
  const [filterCompany, setFilterCompany] = useState(false)
  const [filterPlaces, setFilterPlaces] = useState(false)

  return (
    <div className={styles.filterModal}>
      <CustomModal visible={filterCompany} setVisible={setFilterCompany}>
        <FilterCompanyMobile
          setUserFilter={setUserFilter}
          companies={companies}
          onClickHandler={() => setFilterCompany(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <CustomModal visible={filterPlaces} setVisible={setFilterPlaces}>
        <FilterPlacesMobile
          setPlaceFilter={setPlaceFilter}
          placeNames={placeNames}
          onClickHandler={() => setFilterPlaces(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <div className={styles.header}>
        <ModalHeader title='Фильтры' onClickHandler={onClickHandler} />
      </div>
      <div className={styles.content}>
        <div onClick={() => setFilterCompany(true)} className={styles.itemContainer}>
          <div> Компании </div>
          <img src={arrowLeft} />
        </div>
        <div onClick={() => setFilterPlaces(true)} className={styles.itemContainer}>
          <div> Залы </div>
          <img src={arrowLeft} />
        </div>
      </div>
    </div>
  )
}

export default FilterModal
